import React, { useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaTachometerAlt, FaBox, FaListAlt, FaShoppingCart, FaSignOutAlt, FaUsers, FaBoxes, FaTruck, FaWarehouse, FaChartLine } from 'react-icons/fa';
import { UserContext } from '../App.js';

const Sidebar = () => {
    const { logout, user } = useContext(UserContext); // Ensure 'user' is grabbed here
    const navigate = useNavigate();
    const location = useLocation();

    // Debugging logs based on your output
    console.log("Current User Info:", user);
    console.log("Extracted User ID:", user?.userId);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    // Use 'userId' exactly as it appears in your console log
    const isRestrictedUser = user?.userId === 137;

    return (
        <nav className="bg-gray-900 text-gray-300 w-64 min-h-screen p-6 flex flex-col shadow-xl">
            <div className="flex items-center justify-center mb-10">
                <Link to="/" className="text-white text-3xl font-extrabold tracking-wide">
                    <span className="text-indigo-400">Katabe</span> Admin
                </Link>
            </div>

            <ul className="flex-grow space-y-3">
                {/* 1. Logic: Hide these if userId is 1 */}
                {!isRestrictedUser && (
                    <>
                        <li>
                            <Link to="/" className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/') ? 'bg-indigo-700 text-white font-bold' : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'}`}>
                                <FaTachometerAlt className="w-5 h-5" />
                                <span className="font-medium">Tableau de bord</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/products" className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/products') ? 'bg-indigo-700 text-white font-bold' : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'}`}>
                                <FaBox className="w-5 h-5" />
                                <span className="font-medium">Produits</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/categories" className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/categories') ? 'bg-indigo-700 text-white font-bold' : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'}`}>
                                <FaListAlt className="w-5 h-5" />
                                <span className="font-medium">Catégories</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/inventory" className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/inventory') ? 'bg-indigo-700 text-white font-bold' : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'}`}>
                                <FaWarehouse className="w-5 h-5" />
                                <span className="font-medium">Inventaire</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/analytics" className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/analytics') ? 'bg-indigo-700 text-white font-bold' : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'}`}>
                                <FaChartLine className="w-5 h-5" />
                                <span className="font-medium">Analyses</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/users" className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/users') ? 'bg-indigo-700 text-white font-bold' : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'}`}>
                                <FaUsers className="w-5 h-5" />
                                <span className="font-medium">Clients</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/suppliers" className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/suppliers') ? 'bg-indigo-700 text-white font-bold' : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'}`}>
                                <FaBoxes className="w-5 h-5" />
                                <span className="font-medium">Fournisseurs</span>
                            </Link>
                        </li>
                    </>
                )}

                {/* 2. Logic: These two items always show */}
                <li>
                    <Link to="/orders" className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/orders') ? 'bg-indigo-700 text-white font-bold' : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'}`}>
                        <FaShoppingCart className="w-5 h-5" />
                        <span className="font-medium">Commandes</span>
                    </Link>
                </li>
                <li>
                    <Link to="/delivery" className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/delivery') ? 'bg-indigo-700 text-white font-bold' : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'}`}>
                        <FaTruck className="w-5 h-5" />
                        <span className="font-medium">Livreurs</span>
                    </Link>
                </li>
            </ul>

            <div className="mt-auto pt-4 border-t border-gray-700">
                <button
                    onClick={handleLogout}
                    className="w-full flex items-center space-x-4 p-3 rounded-lg text-red-400 hover:bg-red-900 transition-colors duration-200"
                >
                    <FaSignOutAlt className="w-5 h-5" />
                    <span className="font-medium">Déconnexion</span>
                </button>
            </div>
        </nav>
    );
};

export default Sidebar;